module.exports = __webpack_public_path__ + "img/@tmp_alt.a513fe33.png";